import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import { getComposeCalendarColorScheme } from 'owa-calendar-compose-form-store/lib/selectors/getComposeCalendarColorScheme';
import loc from 'owa-localize';
import { schedulingAssistantHeader } from './FullComposeForm.locstring.json';
import CalendarBar from 'owa-calendar-forms-common/lib/components/CalendarBar';
import { getButtonProps } from '../utils/getFullComposeButtons';
import { shouldShowFormHeader } from '../utils/shouldShowFormHeader';

const styles = require('./FullComposeHeader.scss');

export interface FullComposeHeaderProps {
    formId: string | null;
    showFullScreen: boolean;
}

const FullComposeHeader: React.FunctionComponent<FullComposeHeaderProps> = props => {
    const { formId, showFullScreen } = props;

    if (!shouldShowFormHeader(formId)) {
        // Work Item 58585: Clean code once the teams/channels are added to the cache
        return null;
    }

    const { showSchedulingAssistant } = getFullComposeViewState(formId);
    const colorScheme = getComposeCalendarColorScheme(formId);

    const buttons = getButtonProps(colorScheme, showFullScreen, showSchedulingAssistant);

    const schedulingAssistantHeaderText = showSchedulingAssistant
        ? loc(schedulingAssistantHeader)
        : null;

    return (
        <CalendarBar
            className={styles.calendarBar}
            calendarColorScheme={colorScheme}
            buttonProps={buttons}
            schedulingAssistantHeader={schedulingAssistantHeaderText}
        />
    );
};

export default observer(FullComposeHeader);
